var map = {
	"./bar.jpg": "f6ef",
	"./bottle.png": "6e7c",
	"./coffee.png": "04d5",
	"./dish.png": "5e28",
	"./gyochoumoku.png": "e64a",
	"./lunch.jpg": "c5a6",
	"./morning.jpg": "fbd7",
	"./pakupaku.jpg": "8d46",
	"./sasalunch.jpg": "fba7",
	"./sasalunch.png": "7219",
	"./spicecurry.oourahanten.jpg": "78a4",
	"./tacos.jpg": "0d6f",
	"./teshio_deli_numazu.png": "1987",
	"./ton_meshi.jpg": "ff49",
	"./ton_meshi.png": "b90b",
	"./town_in_town.png": "b205"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7359";